(() => {
  const CATEGORIES = {
    washing: {
      title: 'U ziet een kuipje',
      intro: 'Kies het getal, de hand of het kruis en tel eventuele horizontale strepen direct onder het kuipje.',
      options: [
        ['normal30', '30°C, geen streep', 'Normaal wasproces tot 30°C', 'Wassen tot maximaal 30°C', 'Een normaal huishoudelijk wasproces is toegestaan, met een watertemperatuur van hoogstens 30°C.', 'Kies een normaal programma dat bij de stof past en stel niet hoger dan 30°C in.', '30°C is een maximum, geen verplicht doel. Controleer ook drogen, bleken en strijken.'],
        ['mild30', '30°C, één streep', 'Mild wasproces tot 30°C', 'Mild wassen tot maximaal 30°C', 'De stof vraagt om minder mechanische belasting dan bij een normaal programma.', 'Kies een mild, synthetisch of fijnwasprogramma tot 30°C en beperk de belading.', 'Gebruik geen intensief programma of langdurig, krachtig centrifugeren.'],
        ['veryMild30', '30°C, twee strepen', 'Zeer mild tot 30°C', 'Zeer mild wassen tot maximaal 30°C', 'De stof vraagt om een sterk verminderde mechanische behandeling.', 'Kies een passend zeer mild of wolprogramma tot 30°C en houd de belading duidelijk kleiner.', 'Niet krachtig bewegen, wringen of hard centrifugeren. Controleer of machinaal wassen voor dit artikel past.'],
        ['normal40', '40°C, geen streep', 'Normaal wasproces tot 40°C', 'Wassen tot maximaal 40°C', 'Een normaal huishoudelijk wasproces is toegestaan, met een watertemperatuur van hoogstens 40°C.', 'Kies een normaal programma dat bij de stof past en stel niet hoger dan 40°C in.', 'Sorteer op kleur en stof; 40°C is het maximum en niet automatisch nodig.'],
        ['mild40', '40°C, één streep', 'Mild wasproces tot 40°C', 'Mild wassen tot maximaal 40°C', 'De stof vraagt om een mild programma met minder beweging en doorgaans een kleinere belading.', 'Kies een geschikt mild of kreukherstellend programma tot 40°C.', 'Vermijd een volle trommel en intensief of langdurig centrifugeren.'],
        ['veryMild40', '40°C, twee strepen', 'Zeer mild tot 40°C', 'Zeer mild wassen tot maximaal 40°C', 'Een zeer mild proces is vereist; dit komt onder meer voor bij bepaalde machinewasbare wol.', 'Gebruik een passend zeer mild programma, vul de trommel hoogstens ongeveer voor een derde en volg de machinehandleiding.', 'Niet op een standaard katoenprogramma wassen en niet krachtig centrifugeren.'],
        ['normal60', '60°C, geen streep', 'Normaal wasproces tot 60°C', 'Wassen tot maximaal 60°C', 'Een normaal wasproces is toegestaan tot 60°C, mits de overige onderdelen van het artikel dit ook toelaten.', 'Kies een normaal programma en een temperatuur die past bij vuil, kleur en wasmiddel, nooit hoger dan 60°C.', 'Ga niet uit van 60°C alleen omdat het mag; controleer de hele lading.'],
        ['mild60', '60°C, één streep', 'Mild wasproces tot 60°C', 'Mild wassen tot maximaal 60°C', 'De temperatuur mag tot 60°C, maar de mechanische behandeling moet mild blijven.', 'Kies een mild programma, vul de trommel niet verder dan ongeveer twee derde en centrifugeer voorzichtig.', 'Niet combineren met een intensief katoenprogramma of een volle trommel.'],
        ['normal70', '70°C, geen streep', 'Normaal wasproces tot 70°C', 'Wassen tot maximaal 70°C', 'Een normaal wasproces tot 70°C is toegestaan voor artikelen die daar volgens het volledige label geschikt voor zijn.', 'Gebruik alleen een programma tot 70°C wanneer materiaal, kleur en machinehandleiding dit ondersteunen.', 'Niet toepassen op basis van alleen de vezelnaam; coatings, prints en elastiek kunnen kwetsbaarder zijn.'],
        ['normal95', '95°C, geen streep', 'Normaal kookwasproces', 'Wassen tot maximaal 95°C', 'Een normaal kookwasproces is toegestaan, vooral bij daarvoor geschikt wit katoen of linnen.', 'Kies een hoge temperatuur alleen als de hele lading, het doel en de machinehandleiding dit rechtvaardigen.', 'Gebruik 95°C niet automatisch: het is een maximum en kan onnodig zijn.'],
        ['handAmbient', 'Handwas op omgevingstemperatuur', 'Handwas rond 20–30°C', 'Voorzichtige handwas', 'Was met ruim water op ongeveer 20–30°C en behandel het artikel met zeer weinig beweging.', 'Los een geschikt fijnwasmiddel eerst op, laat het artikel in het water bewegen en druk water voorzichtig uit.', 'Niet wrijven, trekken of wringen en niet lang nat laten liggen.'],
        ['hand40', 'Handwas tot 40°C', 'Handwas tot 40°C', 'Voorzichtige handwas tot maximaal 40°C', 'Handwas is toegestaan met water van hoogstens 40°C.', 'Gebruik ruim water en een geschikt fijnwasmiddel; beweeg, spoel en vorm het artikel voorzichtig.', 'Niet wrijven, trekken, wringen of zonder bevestiging een machineprogramma kiezen.'],
        ['doNotWash', 'Kuipje met een kruis', 'Niet huishoudelijk wassen', 'Niet wassen', 'Het artikel mag niet met een huishoudelijke hand- of machinewas worden gewassen.', 'Controleer de overige professionele onderhoudstekens of raadpleeg een professionele textielreiniger.', 'Niet weken, handwassen of in een huishoudelijke wasmachine plaatsen.']
      ]
    },
    bleaching: {
      title: 'U ziet een driehoek',
      intro: 'Kies of de driehoek leeg is, twee schuine lijnen bevat of met een kruis is doorgestreept.',
      options: [
        ['any', 'Lege driehoek', 'Chloor- of zuurstofbleek toegestaan', 'Alle bleekmiddelen toegestaan', 'Zowel chloorbleek als zuurstofbleek mag worden gebruikt wanneer het product daarvoor geschikt is.', 'Volg exact het etiket van het bleekproduct en controleer kleur, stof en dosering.', 'Meng bleekmiddel nooit met andere reinigers en overschrijd de productinstructies niet.'],
        ['oxygen', 'Twee schuine lijnen', 'Alleen zuurstofbleek', 'Alleen zuurstofbleek toegestaan', 'Zuurstofbleek mag, chloorbleek niet.', 'Controleer of het wasmiddel of vlekproduct zuurstofbleek bevat en geschikt is voor stof en kleur.', 'Gebruik geen chloorbleek en meng nooit verschillende reinigers.'],
        ['none', 'Driehoek met een kruis', 'Niet bleken', 'Geen bleekmiddel gebruiken', 'Bleken is niet toegestaan.', 'Kies alleen een bleekvrij product en lees de ingrediënten en waarschuwingen op het etiket.', 'Gebruik geen chloor- of zuurstofbleek, ook niet als onderdeel van een vlekproduct.']
      ]
    },
    drying: {
      title: 'U ziet een vierkant',
      intro: 'Een cirkel in het vierkant gaat over de droger. Horizontale en verticale lijnen beschrijven natuurlijk drogen; een schuine lijn linksboven voegt drogen in de schaduw toe.',
      options: [
        ['tumbleNormal', 'Cirkel met twee stippen', 'Normaal proces · maximaal 80°C', 'Trommeldrogen op normaal proces', 'Trommeldrogen is toegestaan met een normaal proces en een maximale uitlaatluchttemperatuur van 80°C.', 'Kies een normaal droogprogramma en volg de maximale belading van de droger.', 'Controleer decoraties, elastiek en andere labels voordat u warmte gebruikt.'],
        ['tumbleMild', 'Cirkel met één stip', 'Mild proces · maximaal 60°C', 'Trommeldrogen op mild proces', 'Trommeldrogen is alleen toegestaan met een mild proces en een maximale uitlaatluchttemperatuur van 60°C.', 'Kies een lage-temperatuur- of mild droogprogramma en haal het wasgoed tijdig uit de trommel.', 'Gebruik geen normaal of heet droogprogramma.'],
        ['noTumble', 'Cirkel met een kruis', 'Niet trommeldrogen', 'Niet in de wasdroger', 'Het artikel is niet geschikt voor trommeldrogen.', 'Gebruik een toegestane natuurlijke droogmethode en vorm het artikel zo nodig voorzichtig.', 'Niet kort of koud in de droger doen zonder bevestiging van de fabrikant.'],
        ['line', 'Eén verticale lijn', 'Aan de lijn drogen', 'Aan de lijn drogen', 'Laat het artikel hangend aan een lijn of rek drogen.', 'Verdeel het gewicht en vorm het artikel voordat het volledig droog is.', 'Gebruik geen andere droogmethode als het label die niet toestaat.'],
        ['dripLine', 'Twee verticale lijnen', 'Druipend aan de lijn drogen', 'Druipnat aan de lijn drogen', 'Laat overtollig water vanzelf uitdruipen terwijl het artikel hangt.', 'Hang het artikel zonder krachtig centrifugeren of uitwringen op een geschikte plek.', 'Niet wringen; bescherm vloer en omgeving tegen druipwater.'],
        ['flat', 'Eén horizontale lijn', 'Plat drogen', 'Liggend drogen', 'Laat het artikel vlak en ondersteund drogen om uitrekken te beperken.', 'Leg het in vorm op een schoon, geschikt droogoppervlak met voldoende ventilatie.', 'Niet aan één punt ophangen als het gewicht de vorm kan vervormen.'],
        ['dripFlat', 'Twee horizontale lijnen', 'Druipend plat drogen', 'Druipnat liggend drogen', 'Het artikel moet zonder krachtig water verwijderen vlak drogen.', 'Ondersteun het volledig, vorm voorzichtig en laat het water gecontroleerd weglopen.', 'Niet wringen, hard centrifugeren of hangend laten uitrekken.'],
        ['lineShade', 'Eén verticale lijn + schuine lijn', 'Aan de lijn drogen in de schaduw', 'Aan de lijn drogen in de schaduw', 'Laat het artikel hangend drogen en vermijd direct zonlicht.', 'Hang het artikel aan een lijn of rek op een goed geventileerde plek in de schaduw.', 'Niet in direct zonlicht leggen of hangen.'],
        ['dripLineShade', 'Twee verticale lijnen + schuine lijn', 'Druipend aan de lijn in de schaduw', 'Druipnat aan de lijn drogen in de schaduw', 'Laat overtollig water vanzelf uitdruipen terwijl het artikel in de schaduw hangt.', 'Hang het zonder krachtig centrifugeren of wringen op een geschikte, beschaduwde plek.', 'Niet wringen en niet in direct zonlicht hangen.'],
        ['flatShade', 'Eén horizontale lijn + schuine lijn', 'Plat drogen in de schaduw', 'Liggend drogen in de schaduw', 'Laat het artikel vlak, ondersteund en buiten direct zonlicht drogen.', 'Leg het in vorm op een schoon, ventilerend droogoppervlak in de schaduw.', 'Niet ophangen en niet in direct zonlicht leggen.'],
        ['dripFlatShade', 'Twee horizontale lijnen + schuine lijn', 'Druipend plat in de schaduw', 'Druipnat liggend drogen in de schaduw', 'Laat het artikel zonder krachtig water verwijderen vlak en in de schaduw drogen.', 'Ondersteun het volledig, vorm voorzichtig en laat water gecontroleerd weglopen.', 'Niet wringen, hard centrifugeren, ophangen of in direct zonlicht leggen.']
      ]
    },
    ironing: {
      title: 'U ziet een strijkijzer',
      intro: 'Tel de stippen in het strijkijzer en let ook op een doorgestreepte stoommarkering of een kruis door het hele teken.',
      options: [
        ['low', 'Eén stip', 'Tot 120°C · stoom kan schade geven', 'Strijken tot maximaal 120°C', 'Een lage zooltemperatuur is toegestaan. Stoom kan bij gevoelige artikelen onherstelbare schade veroorzaken.', 'Strijk eventueel binnenstebuiten of met een persdoek en gebruik weinig druk.', 'Ga niet af op alleen de vezelsoort en gebruik niet automatisch stoom.'],
        ['lowNoSteam', 'Eén stip + doorgestreepte stoom', 'Tot 120°C · zonder stoom', 'Strijken tot maximaal 120°C zonder stoom', 'Een lage zooltemperatuur is toegestaan, maar stoom is niet toegestaan.', 'Strijk droog, eventueel binnenstebuiten of met een persdoek, en gebruik weinig druk.', 'Gebruik geen stoomfunctie en ga niet af op alleen de vezelsoort.'],
        ['medium', 'Twee stippen', 'Tot 160°C', 'Strijken tot maximaal 160°C', 'Een matige zooltemperatuur is toegestaan.', 'Gebruik zo nodig een licht vochtige persdoek, beperkte druk en controleer applicaties.', 'Overschrijd 160°C niet en laat het strijkijzer niet stilstaan.'],
        ['hot', 'Drie stippen', 'Tot 210°C', 'Heet strijken tot maximaal 210°C', 'Een hoge zooltemperatuur is toegestaan voor het artikel volgens het volledige label.', 'Strijk zo nodig vochtig of met een persdoek en controleer prints en glansgevoelige delen.', 'Gebruik niet automatisch de hoogste stand; 210°C is het maximum.'],
        ['none', 'Strijkijzer met een kruis', 'Niet strijken', 'Niet strijken', 'Warm strijken kan onherstelbare verandering veroorzaken.', 'Kies een andere toegestane methode om kreukels te verminderen of raadpleeg de fabrikant.', 'Gebruik geen strijkijzer of hete pers.']
      ]
    },
    professional: {
      title: 'U ziet een cirkel',
      intro: 'De letter en strepen zijn technische instructies voor een professionele textielreiniger.',
      options: [
        ['p', 'Letter P, geen streep', 'Professionele droogreiniging: P', 'Professionele droogreiniging toegestaan', 'Een professionele reiniger mag de processen gebruiken die bij de letter P horen.', 'Wijs de reiniger op vlekken en laat het oorspronkelijke label aan het artikel zitten.', 'Probeer deze behandeling niet in een huishoudelijke machine uit te voeren.'],
        ['pMild', 'Letter P, één streep', 'Milde professionele droogreiniging: P', 'Milde professionele droogreiniging', 'De P-behandeling is toegestaan met beperkingen in onder meer mechanische belasting, vocht of temperatuur.', 'Laat een professionele textielreiniger de exacte behandeling bepalen.', 'Gebruik geen standaard huishoudelijk programma als vervanging.'],
        ['f', 'Letter F, geen streep', 'Professionele droogreiniging: F', 'Professionele droogreiniging met F-proces', 'Een professionele reiniger mag een proces met koolwaterstoffen toepassen.', 'Laat de letter en het volledige label aan de professionele reiniger zien.', 'Gebruik thuis geen oplosmiddelen of vlekmiddelen op oplosmiddelbasis zonder uitdrukkelijke geschiktheid.'],
        ['fMild', 'Letter F, één streep', 'Milde professionele droogreiniging: F', 'Mild professioneel F-proces', 'Het F-proces is alleen toegestaan met aanvullende beperkingen.', 'Laat de professionele reiniger de lagere mechanische, vocht- en temperatuurbelasting bewaken.', 'Niet zelf nabootsen met huishoudelijke middelen.'],
        ['noDry', 'Cirkel met een kruis', 'Niet professioneel droogreinigen', 'Niet chemisch reinigen', 'Professionele droogreiniging is niet toegestaan.', 'Controleer of wassen of professionele natreiniging afzonderlijk wel is toegestaan.', 'Gebruik geen vlekverwijderaars met oplosmiddelen zonder bevestigde geschiktheid.'],
        ['wet', 'Letter W, geen streep', 'Professionele natreiniging', 'Professionele natreiniging toegestaan', 'Een professionele natreiniging is toegestaan.', 'Breng het artikel naar een reiniger die professionele natreiniging aanbiedt.', 'Dit is geen gewoon huishoudelijk water- of wasprogramma.'],
        ['wetMild', 'Letter W, één streep', 'Milde professionele natreiniging', 'Mild professioneel natreinigen', 'Professionele natreiniging is toegestaan met verminderde mechanische belasting.', 'Laat de professionele reiniger het milde proces bepalen.', 'Niet vervangen door een huishoudelijk fijnwasprogramma.'],
        ['wetVeryMild', 'Letter W, twee strepen', 'Zeer milde professionele natreiniging', 'Zeer mild professioneel natreinigen', 'Alleen een zeer mild professioneel natreinigingsproces is toegestaan.', 'Kies een professionele reiniger met de juiste apparatuur en expertise.', 'Niet thuis wassen of handwassen tenzij een apart wasteken dit toestaat.'],
        ['noWet', 'Letter W met een kruis', 'Niet professioneel natreinigen', 'Niet professioneel natreinigen', 'Professionele natreiniging is niet toegestaan.', 'Laat een professionele reiniger de andere tekens op het label beoordelen.', 'Niet aannemen dat huishoudelijk wassen daardoor wel is toegestaan.']
      ]
    }
  };

  const getCareAdvice = (category, key) => {
    const group = CATEGORIES[category];
    if (!group) return null;
    const option = group.options.find((item) => item[0] === key);
    if (!option) return null;
    return { key: option[0], label: option[1], badge: option[2], title: option[3], summary: option[4], action: option[5], avoid: option[6] };
  };

  const SVG_NS = 'http://www.w3.org/2000/svg';

  const addSvgNode = (parent, name, attributes = {}, className = '') => {
    const node = document.createElementNS(SVG_NS, name);
    Object.entries(attributes).forEach(([attribute, value]) => node.setAttribute(attribute, value));
    if (className) node.setAttribute('class', className);
    parent.append(node);
    return node;
  };

  const addUse = (svg, name) => {
    const use = addSvgNode(svg, 'use');
    use.setAttribute('href', `#ff-icon-${name}`);
  };

  const addCross = (svg, x1 = 16, y1 = 16, x2 = 48, y2 = 48) => {
    addSvgNode(svg, 'line', { x1, y1, x2, y2 }, 'ff-care-icon__danger');
    addSvgNode(svg, 'line', { x1: x2, y1, x2: x1, y2 }, 'ff-care-icon__danger');
  };

  const addDots = (svg, count, y = 32) => {
    const positions = count === 1 ? [32] : count === 2 ? [27, 37] : [23, 32, 41];
    positions.forEach((cx) => addSvgNode(svg, 'circle', { cx, cy: y, r: 2.45 }, 'ff-care-icon__dot'));
  };

  const addProcessBars = (svg, count) => {
    if (!count) return;
    addSvgNode(svg, 'line', { x1: 18, y1: 55, x2: 46, y2: 55 }, 'ff-care-icon__process');
    if (count === 2) addSvgNode(svg, 'line', { x1: 20, y1: 60, x2: 44, y2: 60 }, 'ff-care-icon__process');
  };

  const createChoiceIcon = (category, key) => {
    const icon = document.createElement('span');
    icon.className = 'ff-wash-pictogram ff-wash-pictogram--choice';
    icon.setAttribute('aria-hidden', 'true');
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 64 64');
    svg.setAttribute('focusable', 'false');
    icon.append(svg);

    if (category === 'washing') {
      const handWash = key.startsWith('hand');
      addUse(svg, handWash ? 'handwash' : 'care-wash-choice');
      if (key === 'doNotWash') {
        addCross(svg, 15, 18, 49, 51);
      } else {
        const temperature = key === 'handAmbient' ? '20–30' : key.match(/\d+/)?.[0];
        if (temperature) {
          const value = document.createElement('b');
          value.className = `ff-wash-pictogram__temperature${handWash ? ' ff-wash-pictogram__temperature--hand' : ''}`;
          value.textContent = `${temperature}°`;
          icon.append(value);
        }
        addProcessBars(svg, key.startsWith('veryMild') ? 2 : key.startsWith('mild') ? 1 : 0);
      }
    } else if (category === 'bleaching') {
      addUse(svg, 'care-bleach-choice');
      if (key === 'oxygen') {
        addSvgNode(svg, 'line', { x1: 24, y1: 43, x2: 35, y2: 23 }, 'ff-care-icon__process');
        addSvgNode(svg, 'line', { x1: 32, y1: 43, x2: 43, y2: 23 }, 'ff-care-icon__process');
      } else if (key === 'none') {
        addCross(svg, 19, 20, 45, 46);
      }
    } else if (category === 'drying') {
      addUse(svg, 'care-dry-choice');
      if (key === 'tumbleNormal' || key === 'tumbleMild' || key === 'noTumble') {
        addSvgNode(svg, 'circle', { cx: 32, cy: 32, r: 14 }, 'ff-care-icon__detail');
        if (key === 'noTumble') addCross(svg, 18, 18, 46, 46);
        else addDots(svg, key === 'tumbleNormal' ? 2 : 1);
      } else {
        const verticalCount = key.startsWith('dripLine') ? 2 : key.startsWith('line') ? 1 : 0;
        const horizontalCount = key.startsWith('dripFlat') ? 2 : key.startsWith('flat') ? 1 : 0;
        if (verticalCount === 1) addSvgNode(svg, 'line', { x1: 32, y1: 19, x2: 32, y2: 45 }, 'ff-care-icon__detail');
        if (verticalCount === 2) {
          addSvgNode(svg, 'line', { x1: 27, y1: 19, x2: 27, y2: 45 }, 'ff-care-icon__detail');
          addSvgNode(svg, 'line', { x1: 37, y1: 19, x2: 37, y2: 45 }, 'ff-care-icon__detail');
        }
        if (horizontalCount === 1) addSvgNode(svg, 'line', { x1: 19, y1: 32, x2: 45, y2: 32 }, 'ff-care-icon__detail');
        if (horizontalCount === 2) {
          addSvgNode(svg, 'line', { x1: 19, y1: 27, x2: 45, y2: 27 }, 'ff-care-icon__detail');
          addSvgNode(svg, 'line', { x1: 19, y1: 37, x2: 45, y2: 37 }, 'ff-care-icon__detail');
        }
        if (key.endsWith('Shade')) addSvgNode(svg, 'line', { x1: 15, y1: 27, x2: 27, y2: 15 }, 'ff-care-icon__process');
      }
    } else if (category === 'ironing') {
      addUse(svg, 'care-iron-choice');
      if (key === 'none') {
        addCross(svg, 14, 15, 50, 49);
      } else {
        addDots(svg, key === 'hot' ? 3 : key === 'medium' ? 2 : 1, 33);
        if (key === 'lowNoSteam') {
          addSvgNode(svg, 'path', { d: 'M43 9c3 2 3 5 0 8M50 9c3 2 3 5 0 8' }, 'ff-care-icon__process');
          addSvgNode(svg, 'line', { x1: 41, y1: 7, x2: 53, y2: 20 }, 'ff-care-icon__danger');
        }
      }
    } else if (category === 'professional') {
      addUse(svg, 'care-professional-choice');
      const letter = key.startsWith('p') ? 'P' : key.startsWith('f') ? 'F' : key.startsWith('wet') || key === 'noWet' ? 'W' : '';
      if (letter) {
        const label = addSvgNode(svg, 'text', { x: 32, y: 35 }, 'ff-care-icon__label');
        label.textContent = letter;
      }
      if (key === 'noDry' || key === 'noWet') addCross(svg, 17, 13, 47, 43);
      else addProcessBars(svg, key === 'wetVeryMild' ? 2 : key.endsWith('Mild') ? 1 : 0);
    } else {
      addUse(svg, 'unknown');
    }
    return icon;
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { CATEGORIES, getCareAdvice };
    return;
  }

  class FfCareGuide extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.categories = this.querySelector('[data-ff-care-categories]');
      this.picker = this.querySelector('[data-ff-care-picker]');
      this.result = this.querySelector('[data-ff-care-result]');
      this.options = this.querySelector('[data-ff-care-options]');
      this.resetButton = this.querySelector('[data-ff-care-reset]');
      this.searchInput = this.querySelector('[data-ff-care-search]');
      this.searchClear = this.querySelector('[data-ff-care-search-clear]');
      this.searchResults = this.querySelector('[data-ff-care-search-results]');
      this.searchCount = this.querySelector('[data-ff-care-search-count]');

      this.querySelectorAll('[data-care-category]').forEach((button) => button.addEventListener('click', () => this.openCategory(button.dataset.careCategory)));
      this.querySelector('[data-ff-care-category-back]')?.addEventListener('click', () => this.showCategories());
      this.querySelector('[data-ff-care-another]')?.addEventListener('click', () => this.showCategories());
      this.resetButton?.addEventListener('click', () => this.showCategories());
      this.searchInput?.addEventListener('input', () => {
        window.clearTimeout(this.searchTimer);
        this.searchTimer = window.setTimeout(() => this.search(), 180);
      });
      this.searchClear?.addEventListener('click', () => { this.clearSearch(true); this.searchInput?.focus(); });
      this.querySelectorAll('[data-ff-care-share]').forEach((control) => control.addEventListener('click', (event) => this.share(event, control.dataset.ffCareShare)));
      this.restoreSharedResult();
    }

    normalize(value) {
      return String(value || '').toLocaleLowerCase('nl-NL').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    }

    search() {
      const raw = this.searchInput?.value || '';
      const query = this.normalize(raw);
      if (this.searchClear) this.searchClear.hidden = !raw;
      if (query.length < 2) {
        if (this.searchResults) { this.searchResults.hidden = true; this.searchResults.replaceChildren(); }
        if (this.searchCount) this.searchCount.hidden = true;
        this.categories.hidden = false;
        return;
      }

      const matches = [];
      const queryWords = query.split(' ').filter(Boolean);
      Object.entries(CATEGORIES).forEach(([category, group]) => {
        group.options.forEach((item) => {
          const haystack = this.normalize([group.title, group.intro, ...item.slice(1)].join(' '));
          if (!queryWords.every((word) => haystack.includes(word))) return;
          const label = this.normalize(item[1]);
          const badge = this.normalize(item[2]);
          const title = this.normalize(item[3]);
          const allWordsIn = (value) => queryWords.every((word) => value.includes(word));
          let score = haystack.includes(query) ? 35 : 10;
          if (allWordsIn(label)) score += label.includes(query) ? 120 : 90;
          if (allWordsIn(title)) score += title.includes(query) ? 105 : 75;
          if (allWordsIn(badge)) score += badge.includes(query) ? 95 : 65;
          matches.push({ category, group, item, score });
        });
      });
      matches.sort((a, b) => b.score - a.score || a.item[1].localeCompare(b.item[1], 'nl-NL'));

      this.categories.hidden = true;
      this.picker.hidden = true;
      this.result.hidden = true;
      this.searchResults.replaceChildren();
      const visibleMatches = matches.slice(0, 12);

      if (!visibleMatches.length) {
        this.categories.hidden = false;
        const empty = document.createElement('p');
        empty.className = 'ff-wash-guide__search-empty';
        empty.textContent = 'Geen directe overeenkomst. Probeer een korter woord of kies hieronder eerst de vorm van het teken.';
        this.searchResults.append(empty);
      } else {
        visibleMatches.forEach(({ category, group, item }) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ff-wash-guide__search-result';
          const copy = document.createElement('span');
          const title = document.createElement('strong');
          const hint = document.createElement('small');
          title.textContent = item[1];
          hint.textContent = `${group.title.replace('U ziet een ', '')} · ${item[2]}`;
          copy.append(title, hint);
          button.append(createChoiceIcon(category, item[0]), copy);
          button.addEventListener('click', () => {
            this.currentCategory = category;
            this.track('ff_care_search_select', { query_length: query.length, category, option: item[0] });
            this.showResult(item[0]);
          });
          this.searchResults.append(button);
        });
      }

      this.searchResults.hidden = false;
      this.searchCount.textContent = matches.length === 1 ? '1 resultaat gevonden' : `${matches.length} resultaten gevonden${matches.length > 12 ? '; de eerste 12 worden getoond' : ''}`;
      this.searchCount.hidden = false;
      this.track('ff_care_search', { query_length: query.length, result_count: matches.length });
    }

    clearSearch(showCategories = false) {
      if (this.searchInput) this.searchInput.value = '';
      if (this.searchClear) this.searchClear.hidden = true;
      if (this.searchResults) { this.searchResults.hidden = true; this.searchResults.replaceChildren(); }
      if (this.searchCount) { this.searchCount.hidden = true; this.searchCount.textContent = ''; }
      if (showCategories) this.categories.hidden = false;
    }

    openCategory(key) {
      const group = CATEGORIES[key];
      if (!group) return;
      this.currentCategory = key;
      this.querySelector('[data-ff-care-category-title]').textContent = group.title;
      this.querySelector('[data-ff-care-category-intro]').textContent = group.intro;
      this.options.replaceChildren(...group.options.map((item) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ff-wash-guide__choice-button--icon';
        button.dataset.careOption = item[0];
        const copy = document.createElement('span');
        copy.className = 'ff-wash-guide__choice-copy';
        const title = document.createElement('strong');
        const hint = document.createElement('small');
        title.textContent = item[1];
        hint.textContent = item[2];
        copy.append(title, hint);
        button.append(createChoiceIcon(key, item[0]), copy);
        button.addEventListener('click', () => this.showResult(item[0]));
        return button;
      }));
      this.categories.hidden = true;
      this.result.hidden = true;
      this.picker.hidden = false;
      this.resetButton.hidden = false;
      this.picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.track('ff_care_category', { category: key });
    }

    showResult(key, options = {}) {
      const advice = getCareAdvice(this.currentCategory, key);
      if (!advice) return;
      this.querySelector('[data-ff-care-result-title]').textContent = advice.title;
      this.querySelector('[data-ff-care-result-badge]').textContent = advice.badge;
      this.querySelector('[data-ff-care-result-summary]').textContent = advice.summary;
      this.querySelector('[data-ff-care-result-do]').textContent = advice.action;
      this.querySelector('[data-ff-care-result-avoid]').textContent = advice.avoid;
      this.categories.hidden = true;
      this.picker.hidden = true;
      this.searchResults.hidden = true;
      this.result.hidden = false;
      this.updateShareLinks(key);
      if (options.scroll !== false) this.result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (options.completion !== false) {
        this.track('ff_care_result', { category: this.currentCategory, option: key });
        window.FFToolInsights?.complete(this, `${this.currentCategory}:${key}`, { category: this.currentCategory, option: key });
      }
    }

    showCategories() {
      this.currentCategory = '';
      this.picker.hidden = true;
      this.result.hidden = true;
      this.clearSearch();
      this.categories.hidden = false;
      this.resetButton.hidden = true;
      window.FFToolInsights?.resetRun(this);
      const url = new URL(window.location.href);
      url.searchParams.delete('symboolgroep');
      url.searchParams.delete('symbool');
      url.searchParams.delete('shared');
      window.history.replaceState({}, '', url);
      this.categories.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    updateShareLinks(key) {
      const url = new URL(window.location.href);
      url.searchParams.set('symboolgroep', this.currentCategory);
      url.searchParams.set('symbool', key);
      url.searchParams.delete('shared');
      window.history.replaceState({}, '', url);
      const shareUrl = new URL(url); shareUrl.searchParams.set('shared', '1'); this.shareUrl = shareUrl.toString();
      this.dataset.ffToolResultKey = `${this.currentCategory}:${key}`;
      const advice = getCareAdvice(this.currentCategory, key);
      const text = `FashFresh Waslabelhulp: ${advice?.title || 'uitleg van een wassymbool'}. Het volledige waslabel blijft leidend.`;
      const whatsapp = this.querySelector('[data-ff-care-share="whatsapp"]');
      const facebook = this.querySelector('[data-ff-care-share="facebook"]');
      if (whatsapp) { whatsapp.href = `https://wa.me/?text=${encodeURIComponent(`${text} ${this.shareUrl}`)}`; whatsapp.target = '_blank'; whatsapp.rel = 'noopener'; }
      if (facebook) { facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareUrl)}`; facebook.target = '_blank'; facebook.rel = 'noopener'; }
      this.shareText = text;
    }

    async share(event, platform) {
      if (platform === 'whatsapp' || platform === 'facebook') return;
      event.preventDefault();
      const payload = { title: 'FashFresh Waslabelhulp', text: this.shareText || 'Bekijk deze uitleg van een wassymbool.', url: this.shareUrl || window.location.href };
      try {
        if (platform === 'native' && navigator.share) { await navigator.share(payload); window.FFToolInsights?.push('ff_tool_share_success', { tool: this.dataset.ffTool, platform: 'native', result_key: this.dataset.ffToolResultKey }); }
        else if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(`${payload.text} ${payload.url}`); window.FFToolInsights?.push('ff_tool_share_success', { tool: this.dataset.ffTool, platform: 'copy', result_key: this.dataset.ffToolResultKey }); }
        else throw new Error('clipboard-unavailable');
        if (platform !== 'native' || !navigator.share) this.showShareStatus('Link en uitleg gekopieerd.');
      } catch (error) {
        if (error?.name !== 'AbortError') this.showShareStatus('Delen lukte niet. Kopieer de URL uit de adresbalk.');
      }
    }

    showShareStatus(message) {
      const status = this.querySelector('[data-ff-care-share-status]');
      if (!status) return;
      status.textContent = message;
      status.hidden = false;
    }

    restoreSharedResult() {
      const params = new URLSearchParams(window.location.search);
      const category = params.get('symboolgroep');
      const key = params.get('symbool');
      if (!getCareAdvice(category, key)) return;
      this.currentCategory = category;
      this.resetButton.hidden = false;
      this.showResult(key, { scroll: false, completion: false });
      if (params.get('shared') === '1') window.FFToolInsights?.push('ff_tool_shared_result_view', { tool: 'waslabelhulp', result_key: `${category}:${key}` });
    }

    track(eventName, detail) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...detail });
    }
  }

  if (!customElements.get('ff-care-guide')) customElements.define('ff-care-guide', FfCareGuide);
})();
